const Images = {
  logo: require("./logo4.png"),
  headerLogo: require("./logo3.png"),
  user: require("./user.jpg"),
  profileImage: require("./profileImage.png"),
  authorImage: require("./authorImage.png"),
  courseImage: require("./courseImage.png"),
  instructor1: require("./instructor1.png"),
  instructor2: require("./instructor2.png"),
  user_ticket_image: require("./user_ticket_image.png"),
};

export default Images;